export default class webglListBack{
    constructor(kv,btn){

        this.kv = kv;
        this.btn = btn;

    }

    /* ---------------------------------------------------

　　　-- 詳細から一覧に戻る

    --------------------------------------------------- */

    set(){

        this.kv.status.rendering = false;

        let tl = new TimelineMax({
            onUpdate:function(){

            }
        });

        this.btn.hide();
        TweenMax.staggerTo(this.kv.detailNumber[this.kv.status.index].children, .7 ,{
            y:'100%',
        },0.05);
        TweenMax.to([this.kv.detailEn[this.kv.status.index].children,this.kv.detailJp[this.kv.status.index].children,this.kv.detailText[this.kv.status.index]], .5 ,{
            opacity:0,
            y:'50px',
            ease: Sine.easeOut,
        });

        if(Useragnt.mobile || Useragnt.tablet){
            window.mv_main.listFromDetail({
                activeItemId:null
            });
            for(let i=0; this.kv.detailContent.length>i; i++) {
                TweenMax.set(this.kv.detailContent[i], {
                    delay:0.8,
                    opacity: 0,
                    display: 'none',
                });
            }
            TweenMax.fromTo(this.kv.pager, .3 , {
                scale: 0.8,
                opacity: 0,
            },{
                delay:0.2,
                scale:1,
                opacity: 1,
                ease: this.kv.easeBack,
            });
        }else{
            TweenMax.to(this.kv.pager,0.6, {
                display: 'none',
                opacity: 0,
                scale: 0.8,
                ease: this.kv.easeBack,
            });
            TweenMax.to(this.kv.headerTitle,0.6, {
                display: 'none',
                opacity: 0,
                scale: 0.8,
                ease: Sine.easeOut,
            });
            TweenMax.set(this.kv.detailContent[this.kv.status.index].querySelectorAll('.fake-image'), {
                opacity:0,
                display:'none',
            });
            tl.to(this.kv.detailContent[this.kv.status.index], 0.25, {
                x: '10%',
                y: '30%',
                rotation:-7,
                transformOrigin: "50% 0%",
                onStart:() => {
                    TweenMax.to(document.getElementById('canvas'), 0.6 ,{
                        opacity:1,
                        ease: Circ.easeOut,
                        onStart:() => {
                            window.mv_main.resumeRender();
                            let _index = Number(this.kv.status.index) + 1;
                            window.mv_main.listFromDetail({
                                activeItemId:_index
                            });
                            TweenMax.fromTo(this.kv.back, 0.6, {
                                opacity : 0,
                                scale:0.8,
                            },{
                                opacity: 1,
                                display: 'block',
                                scale:1,
                                ease: Sine.easeOut,
                            });
                        }
                    });
                }
            }).to(this.kv.detailContent[this.kv.status.index], 0.8, {
                z:-15,
                x: '-100%',
                y: '-120%',
                rotation:-15,
                transformOrigin: "50% 0%"
            });
        }

        TweenMax.fromTo(this.kv.back, 0.6, {
            opacity : 0,
            display: 'none',
            scale:0.8,
        },{
            scale:1,
            opacity: 1,
            display: 'block',
            ease: Sine.easeOut,
        });

        TweenMax.to(this.kv.close, 0.4 ,{
            display: 'none',
            opacity: 0,
            scale:0.5,
            transformOrigin: "100% 0%",
            ease: Circ.easeInOut,
        });

    }


}